module.exports = __webpack_public_path__ + "resources/img/img_ai_easymaker_m_jp.e91a3892541f93c53f5397ac3bd915b5.png";